module.exports = __webpack_public_path__ + "img/icon_fan.e8d74eef.svg";